import { NeMoDataset } from "./types";


export const NEMO_DATASETS: NeMoDataset[] = [
  // ============================================
  // LLM Datasets
  // ============================================
  {
    id: 'dolly-15k',
    name: 'databricks-dolly-15k',
    displayName: 'Databricks Dolly 15K',
    task: 'llm',
    format: 'jsonl',
    trainCount: 13000,
    valCount: 2000,
    totalSize: '50 MB',
    status: 'ready',
    path: '/workspace/data/dolly-15k',
    description: 'High-quality instruction-following dataset with diverse tasks',
    formatExample: '{"messages": [{"role": "user", "content": "What is machine learning?"}, {"role": "assistant", "content": "Machine learning is a subset of AI..."}]}',
  },
  {
    id: 'openassistant-curated',
    name: 'openassistant-curated',
    displayName: 'OpenAssistant Curated',
    task: 'llm',
    format: 'jsonl',
    trainCount: 45000,
    valCount: 5000,
    totalSize: '200 MB',
    status: 'ready',
    path: '/workspace/data/openassistant',
    description: 'Community-curated conversational dataset with multi-turn dialogues',
    formatExample: '{"messages": [{"role": "system", "content": "You are helpful."}, {"role": "user", "content": "Hello"}, {"role": "assistant", "content": "Hi! How can I help?"}]}',
  },
  {
    id: 'alpaca-cleaned',
    name: 'alpaca-cleaned',
    displayName: 'Stanford Alpaca Cleaned',
    task: 'llm',
    format: 'jsonl',
    trainCount: 48000,
    valCount: 4000,
    totalSize: '45 MB',
    status: 'ready',
    path: '/workspace/data/alpaca-cleaned',
    description: 'Cleaned version of Stanford Alpaca with fixed formatting issues',
    formatExample: '{"messages": [{"role": "user", "content": "Give three tips for staying healthy."}, {"role": "assistant", "content": "1. Exercise regularly..."}]}',
  },
  {
    id: 'code-alpaca',
    name: 'code-alpaca',
    displayName: 'Code Alpaca 20K',
    task: 'llm',
    format: 'jsonl',
    trainCount: 18000,
    valCount: 2000,
    totalSize: '35 MB',
    status: 'ready',
    path: '/workspace/data/code-alpaca',
    description: 'Code generation and explanation dataset',
    formatExample: '{"messages": [{"role": "user", "content": "Write a Python function to sort a list"}, {"role": "assistant", "content": "def sort_list(lst):\\n    return sorted(lst)"}]}',
  },
  // ============================================
  // ASR Datasets
  // ============================================
  {
    id: 'librispeech-clean',
    name: 'librispeech-clean',
    displayName: 'LibriSpeech Clean',
    task: 'asr',
    format: 'json_manifest',
    trainCount: 28539,
    valCount: 2703,
    totalSize: '30 GB',
    status: 'ready',
    path: '/workspace/data/librispeech-clean',
    description: 'Clean subset of LibriSpeech audiobook recordings',
    language: 'en',
    formatExample: '{"audio_filepath": "/path/to/audio.wav", "text": "transcription text", "duration": 12.5}',
  },
  {
    id: 'librispeech-other',
    name: 'librispeech-other',
    displayName: 'LibriSpeech Other',
    task: 'asr',
    format: 'json_manifest',
    trainCount: 33236,
    valCount: 2939,
    totalSize: '35 GB',
    status: 'ready',
    path: '/workspace/data/librispeech-other',
    description: 'More challenging subset with varied recording conditions',
    language: 'en',
    formatExample: '{"audio_filepath": "/path/to/audio.wav", "text": "transcription text", "duration": 8.3}',
  },
  {
    id: 'common-voice-en',
    name: 'common-voice-en',
    displayName: 'Common Voice English',
    task: 'asr',
    format: 'json_manifest',
    trainCount: 120000,
    valCount: 15000,
    totalSize: '85 GB',
    status: 'ready',
    path: '/workspace/data/common-voice-en',
    description: 'Crowdsourced multilingual speech corpus - English subset',
    language: 'en',
    formatExample: '{"audio_filepath": "/path/to/audio.mp3", "text": "transcription", "duration": 5.2}',
  },
  {
    id: 'voxpopuli-en',
    name: 'voxpopuli-en',
    displayName: 'VoxPopuli English',
    task: 'asr',
    format: 'json_manifest',
    trainCount: 180000,
    valCount: 4600,
    totalSize: '120 GB',
    status: 'ready',
    path: '/workspace/data/voxpopuli-en',
    description: 'European Parliament recordings for parliamentary speech recognition',
    language: 'en',
    formatExample: '{"audio_filepath": "/path/to/audio.ogg", "text": "speech text", "duration": 15.0}',
  },
  // ============================================
  // TTS Datasets
  // ============================================
  {
    id: 'ljspeech',
    name: 'ljspeech',
    displayName: 'LJSpeech',
    task: 'tts',
    format: 'json_manifest',
    trainCount: 12500,
    valCount: 500,
    totalSize: '2.6 GB',
    status: 'ready',
    path: '/workspace/data/ljspeech',
    description: 'Single female speaker English speech dataset',
    language: 'en',
    formatExample: '{"audio_filepath": "/path/to/audio.wav", "text": "text to speak", "duration": 8.5, "speaker": 0}',
  },
  {
    id: 'vctk',
    name: 'vctk',
    displayName: 'VCTK Corpus',
    task: 'tts',
    format: 'json_manifest',
    trainCount: 40000,
    valCount: 4000,
    totalSize: '10 GB',
    status: 'ready',
    path: '/workspace/data/vctk',
    description: 'Multi-speaker English corpus with 110 speakers',
    language: 'en',
    formatExample: '{"audio_filepath": "/path/to/audio.wav", "text": "utterance text", "duration": 4.2, "speaker": 15}',
  },
  {
    id: 'hifi-tts',
    name: 'hifi-tts',
    displayName: 'HiFi-TTS',
    task: 'tts',
    format: 'json_manifest',
    trainCount: 290000,
    valCount: 2000,
    totalSize: '44 GB',
    status: 'ready',
    path: '/workspace/data/hifi-tts',
    description: 'High-fidelity multi-speaker TTS dataset',
    language: 'en',
    formatExample: '{"audio_filepath": "/path/to/audio.wav", "text": "text content", "duration": 6.7, "speaker": 8}',
  },
];
